module.exports = __webpack_public_path__ + "img/mkw-branding.e017247d.png";